import { VenlyConnect } from "@venly/connect";
const { REACT_APP_VENLY_CLIENT_ID } = process.env;
const { REACT_APP_VENLY_ENV } = process.env;

export const venlyConnect = new VenlyConnect(REACT_APP_VENLY_CLIENT_ID, {
  environment: REACT_APP_VENLY_ENV,
});
